import { InputBase, FormHelperText, InputAdornment, IconButton } from "@mui/material";
import PropTypes from "prop-types";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import Iconify from "src/components/Iconify";

Password.propTypes = {
  name: PropTypes.string.isRequired,
  sx: PropTypes.object,
  placeholder: PropTypes.string,
};

export default function Password({
  name,
  sx,
  placeholder,
  ...other
}) {
  const { control } = useFormContext();
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <>
          <InputBase
            {...field}
            fullWidth
            type={showPassword ? "text" : "password"}
            placeholder={t(placeholder)}
            required
            error={!!error}
            {...other}
            sx={{
              // Changed from #e8f0ff to transparent
              backgroundColor: "rgba(255, 255, 255, 0.15)",
              border: "1px solid rgba(255, 255, 255, 0.3)",
              borderRadius: 1,
              px: "18px",
              py: "8px",
              backdropFilter: "blur(0.6px)",
              "& .MuiInputBase-input": {
                color: "#FFFFFF",
                padding: 0,
                "&::placeholder": {
                  color: "rgba(255, 255, 255, 0.7)",
                  opacity: 1,
                },

                // Updated autofill styles to transparent
                "&:-webkit-autofill": {
                  WebkitBoxShadow: "0 0 0 1000px transparent inset !important",
                  WebkitTextFillColor: "#ffffff !important",
                  caretColor: "#ffffff !important",
                  backgroundColor: "transparent !important",
                  borderRadius: "inherit",
                  transition: "background-color 5000s ease-in-out 0s",
                },
                "&:-webkit-autofill:hover": {
                  WebkitBoxShadow: "0 0 0 1000px transparent inset !important",
                },
                "&:-webkit-autofill:focus": {
                  WebkitBoxShadow: "0 0 0 1000px transparent inset !important",
                },
                "&:autofill": {
                  backgroundColor: "transparent !important",
                  color: "#ffffff !important",
                },
                "&::selection": {
                  backgroundColor: "rgba(0, 0, 0, 0.2)",
                },
              },

              "&.Mui-focused": {
                borderColor: "#2a2a2aff",
                borderWidth: "2px",
                outline: "none",
              },
              ...sx,
            }}

            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  edge="end"
                  onClick={() => setShowPassword((prev) => !prev)}
                  tabIndex={-1}
                  size="small"
                  // Optional: Style the icon button for better visibility on transparent background
                  sx={{
                    backgroundColor: "transparent",
                    "&:hover": {
                      backgroundColor: "rgba(0, 0, 0, 0.04)",
                    },
                  }}
                >
                  <Iconify
                    icon={showPassword ? "fa-solid:eye" : "eva:eye-off-fill"}
                    sx={{
                      color: "#a1a1a1", // Ensure icon is visible
                    }}
                  />
                </IconButton>
              </InputAdornment>
            }
          />
          {error && (
            <FormHelperText error sx={{ mt: 1, mx: 0 }}>
              {error.message}
            </FormHelperText>
          )}
        </>
      )}
    />
  );
}